import React,{Component} from "react";

class Register_form extends React.Component{
    render(){
        return(
            <div>
                <form method="post" id="utf-register-account-form">
                    <div className="utf-no-border margin-bottom-20">
                	<select className="utf-chosen-select-single-item utf-with-border" title="Single User">
                		<option>Single User</option>
                		<option>Agent</option>
                		<option>Multi User</option>				
                	</select>
                    </div>
                    <div className="utf-no-border">
                      <input type="text" name="name" id="name" placeholder="User Name" onChange={this.registerformData} required/>
                    </div>
                    <div className="utf-no-border">
                      <input type="text" name="emailaddress-register" id="emailaddress-register" onChange={this.registerformData} placeholder="Email Address" required/>
                    </div>
                    <div className="utf-no-border">
                      <input type="password" name="password-register" id="password-register" onChange={this.registerformData} placeholder="Password" required/>
                    </div>
                    <div className="utf-no-border">
                      <input type="password" name="password-repeat-register" id="password-repeat-register" onChange={this.registerformData} placeholder="Repeat Password" required/>
                    </div>
                    <div className="checkbox margin-top-0">
                	<input type="checkbox" id="two-step0" onChange={this.registerformData} />
                	<label htmlFor="two-step0"><span className="checkbox-icon"></span> By Registering You Confirm That You Accept <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a></label>
                    </div>
                </form>
                <button className="margin-top-10 button full-width utf-button-sliding-icon ripple-effect" type="submit" form="utf-register-account-form">Register <i className="icon-feather-chevrons-right"></i></button>
                <div className="utf-social-login-separator-item"><span>or</span></div>
                <div className="utf-social-login-buttons-block">
                  <button className="facebook-login ripple-effect"><i className="icon-brand-facebook-f"></i> Facebook</button>
                   <button className="google-login ripple-effect"><i className="icon-brand-google-plus-g"></i> Google+</button>
                   <button className="twitter-login ripple-effect"><i className="icon-brand-twitter"></i> Twitter</button>
                </div>
            </div>
        )
    }
}


export default Register_form;